jQuery(document).ready(function($){
    if ( $('.nf-insights-slider') ) {
        $('.nf-insights-slider-inner').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: '',
            nextArrow: '<button><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M12.3336 15.3085L11.7455 14.7109L15.1426 11.3138H5.11133V10.483H15.1426L11.7455 7.08589L12.3336 6.48828L16.7437 10.8984L12.3336 15.3085Z" fill="#999999"/></svg></button>',
            appendArrows: $('.nf-insights-slider-nav'),
            variableWidth: true,
         
        });

        if ($('.nf-insights-slider-nav')) {
            function alignArrows() {
                const arrows = $('.nf-insights-slider-nav');
                arrows.css('left', '');

                if ($(window).width() > 992) {
                    return;
                }

                const currentSlide = $('.nf-insights-slider-inner .slick-current');
                const offset = currentSlide.width() - arrows.width() / 2;
                arrows.css('left', offset );
            }

            alignArrows();

            $(window).on('resize', function(){
                alignArrows();
            });
        }
    }
});